import classNames from 'clsx';
import type { SyntheticEvent } from 'react';
import React from 'react';
import { useSelector } from 'react-redux';

import Arrow from '@swf/core/assets/icons/arrow.svg';
import Language from '@swf/core/assets/language.svg';
import { select } from '@swf/core/store';

// TODO refactor to use composition or shared.scss
// eslint-disable-next-line no-restricted-imports
import styles from '../LocalesDropDown.scss';

interface Props {
  className?: string;
  ref?: React.Ref<HTMLLIElement>;
  menuVisible: boolean;
  onClick: (e: SyntheticEvent) => void;
}

const LocalesLink = React.forwardRef<HTMLLIElement, Props>(({ menuVisible, ...rest }, ref) => {
  const locale = useSelector(select.locale.get);

  return (
    <li ref={ref} {...rest}>
      <div className={styles.language}>
        <span className={styles.localeIcon}>
          <Language />
        </span>
        <p>{locale.replace(/_/, ' ')}</p>
        <Arrow className={classNames(styles.icon, { [styles.closed]: !menuVisible })} />
      </div>
    </li>
  );
});

export default LocalesLink;
